import { render, staticRenderFns } from "./Wp_jd_action_info.vue?vue&type=template&id=a50c68de&scoped=true&"
import script from "./Wp_jd_action_info.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_action_info.vue?vue&type=script&lang=js&"
import style0 from "./Wp_jd_action_info.vue?vue&type=style&index=0&id=a50c68de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50c68de",
  null
  
)

export default component.exports